<div class="notifications-page">

  <!-- Red title bar with filter actions (matches the reference screenshot) -->
  <div class="panel-header">
    <span class="panel-title">{{ title }}</span>
    <div class="panel-actions">
      <button type="button" class="header-action-button" mat-icon-button title="Filter" (click)="openFilterDialog()">
        <mat-icon class="header-action">filter_list</mat-icon>
      </button>
      <button
        type="button"
        class="header-action-button"
        mat-icon-button
        title="Clear filters"
        [disabled]="!hasDialogFilterApplied"
        (click)="clearFilterAction()">
        <mat-icon class="header-action">filter_list_off</mat-icon>
      </button>
    </div>
  </div>

  <div *ngIf="isLoading" class="state-message">Loading…</div>

  <div *ngIf="!isLoading" class="table-wrapper">
    <table mat-table [dataSource]="rows" class="data-table">

      <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
        <th mat-header-cell *matHeaderCellDef
            class="clickable-header"
            [style.width.px]="columnWidths[column]"
            [style.min-width.px]="columnWidths[column]"
            [style.max-width.px]="columnWidths[column]"
            (click)="onHeaderClick(column)">
          <div class="header-content">
            <span class="th-label">{{ columnLabels[column] }}</span>
            <mat-icon class="sort-icon" *ngIf="getSortIndicator(column) as ind">{{ ind }}</mat-icon>
            <mat-icon class="sort-icon inactive" *ngIf="!getSortIndicator(column)">unfold_more</mat-icon>
          </div>

          <!-- Resize handle (drag the right edge to set column width) -->
          <div class="resize-handle"
               (mousedown)="onResizeStart($event, column)"
               (click)="$event.stopPropagation()"></div>
        </th>

        <td mat-cell *matCellDef="let row"
            [style.width.px]="columnWidths[column]"
            [style.min-width.px]="columnWidths[column]"
            [style.max-width.px]="columnWidths[column]">
          <ng-container [ngSwitch]="isDateColumn(column)">
            <span *ngSwitchCase="true">{{ row[column] | date: 'MM/dd/yyyy HH:mm:ss' }}</span>
            <span *ngSwitchDefault>{{ row[column] }}</span>
          </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index"
          [class.selected]="i === selectedIndex"
          (click)="selectRow(i)"></tr>
    </table>

    <!-- Empty state — broken-puzzle glyph + message, like the screenshot. -->
    <div *ngIf="rows.length === 0" class="empty-state">
      <div class="empty-text">No data to display</div>
      <mat-icon class="empty-icon">extension_off</mat-icon>
    </div>
  </div>

  <!-- Footer summary -->
  <div *ngIf="!isLoading" class="panel-footer">
    Rows: {{ rows.length }} | Page Size: {{ pageSize }} | Current Page: {{ currentPage }}
  </div>
</div>
